import React from 'react';

const PhoneInput = ({
    value = '',
    onChange,
    name,
    label,
    labelFor,
    placeholder,
    isRequired = false,
    error,
    disabled,
    onBlur,
    showRequiredIndicator = true, // New prop to control asterisk visibility
}) => {
    const PREFIX = '+374';
    
    // Extract the number part (everything after +374)
    const getNumberPart = (fullValue) => {
        if (!fullValue) return '';
        if (fullValue.startsWith(PREFIX)) {
            return fullValue.substring(PREFIX.length);
        }
        // If it doesn't start with prefix, return as is (for backwards compatibility)
        return fullValue.replace(/^\+374/, '');
    };
    
    const numberPart = getNumberPart(value);
    
    const handleChange = (e) => {
        const inputValue = e.target.value;
        // Only allow digits
        const digitsOnly = inputValue.replace(/\D/g, '');
        // Limit to 8 digits
        const limitedDigits = digitsOnly.slice(0, 8);
        // Combine prefix with digits
        const fullValue = PREFIX + limitedDigits;
        
        // Create synthetic event
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                name: name,
                value: fullValue
            }
        };
        
        onChange(syntheticEvent);
    };
    
    const handleKeyDown = (e) => {
        // Allow backspace/delete to work normally - don't prevent it
        // The input will handle clearing naturally
    };
    
    const handleFocus = (e) => {
        // Move cursor to the end of the number part
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(input.value.length, input.value.length);
        }, 0);
    };
    
    return (
        <div className="mb-4">
            {label && (
                <label
                    htmlFor={labelFor}
                    className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2"
                >
                    {label} {isRequired && showRequiredIndicator && <span className="text-red-500 dark:text-red-400">*</span>}
                </label>
            )}
            <div className="relative w-full">
                <div 
                    className={`flex items-center rounded-md ${error ? "ring-2 ring-red-500 dark:ring-red-400" : ""} focus-within:ring-2 focus-within:ring-gray-500 dark:focus-within:ring-gray-400`}
                    tabIndex={-1}
                >
                    {/* Fixed Prefix */}
                    <div className={`px-4 py-2 bg-white dark:bg-[#0d1117] border border-r-0 rounded-l-md text-sm font-medium text-gray-700 dark:text-[#c9d1d9] ${
                        error ? "border-red-500 dark:border-red-400" : "border-gray-300 dark:border-[#30363d]"
                    }`}>
                        {PREFIX}
                    </div>
                    {/* Number Input */}
                    <input
                        id={labelFor}
                        name={name}
                        value={numberPart}
                        onChange={handleChange}
                        onBlur={onBlur}
                        onKeyDown={handleKeyDown}
                        onFocus={handleFocus}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={8}
                        placeholder={placeholder || "XX XXX XXX"}
                        disabled={disabled}
                        className={`px-4 py-2 flex-1 bg-white dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] placeholder:text-[14px] placeholder:font-normal placeholder:text-gray-400 dark:placeholder:text-[#6e7681] text-sm border border-l-0 rounded-r-md focus:outline-none ${
                            error ? "border-red-500 dark:border-red-400" : "border-gray-300 dark:border-[#30363d]"
                        } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
                    />
                </div>
                {error && (
                    <p className="text-red-500 dark:text-red-400 text-xs mt-1 font-medium">{error}</p>
                )}
            </div>
        </div>
    );
};

export default PhoneInput;

